import { Link } from "react-router-dom";
import { Href } from "../../../../../constants";
import { GridOption } from "../../../../../data/applications/ECommerce";
import { useAppDispatch } from "../../../../../reduxToolkit/hooks";
import { setColView } from "../../../../../reduxToolkit/reducers/eCommerce/filterSlice";

// This component renders a list of grid display options that allow users to change the column view dynamically.
const DisplayOptions = () => {
  const dispatch = useAppDispatch();

  return (
    <div className="grid-options d-inline-block">
      <ul>
        {GridOption.map((data, index) => (
          <li key={index} onClick={() => dispatch(setColView(data.colClass))}>
            <Link to={Href}>
              {data.filterData.map((item, number) => (
                <span key={number} className={`line-grid line-grid-${item} bg-primary`}></span>
              ))}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DisplayOptions;